/*
  Testimonial slider
*/

export function testimonialSlider() {
  var cellAlignValue = '';

  if (matchMedia('screen and (max-width: 767px)').matches) {
    cellAlignValue = 'center';
  } else {
    cellAlignValue = 'left';
  }

  var $testimonials = $('.testimonials-section.slider.base-testimonials .testimonials-row').flickity({
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
    cellAlign: cellAlignValue,
  });

  $('.testimonials-section.slider.base-testimonials').each(function () {
    $(this).find('.flickity-button').appendTo($(this).find('.flickity-button-wrp'));
  });

  if (matchMedia('screen and (max-width: 1199px)').matches) {
    $('.testimonials-section.slider .testimonials-row').removeClass('no-flickity-testimonial');
    if ($('.testimonials-section.slider.base-testimonials .testimonials-row .testimonials-item-wrp').length > 1) {
      $testimonials.flickity();
      $('.testimonials-section.slider.base-testimonials .testimonials-row').flickity('resize');
    } else {
      $testimonials.flickity('destroy');
    }
  } else if (matchMedia('screen and (min-width: 1200px)').matches) {
    if ($('.testimonials-section.slider.base-testimonials .testimonials-row .testimonials-item-wrp').length > 2) {
      $testimonials.flickity();
    } else {
      $testimonials.flickity('destroy');
      $('.testimonials-section.slider.base-testimonials .testimonials-row').flickity('resize');
      $('.testimonials-section.slider.base-testimonials .testimonials-row').addClass('no-flickity-testimonial');
    }
  }
}